module.exports = __webpack_public_path__ + "img/code-analysis.d9fc4b32.jpg";